/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

type Props = {
  jsonData: any;
};
export const AuditTableCodeView: React.FC<Props> = ({ jsonData }) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button color="primary" onClick={toggle}>
        Visualizar
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Visualização de JSON</ModalHeader>
        <ModalBody>
          <code>{JSON.stringify(jsonData, null, 2)}</code>
        </ModalBody>
      </Modal>
    </div>
  );
};
